
const styles =  {
    image: {
        position: "relative",
        margin: "0 auto",
        width: "100vw",
        height: `100%`,
        transition: "300ms ease",
    },
    
    hidden: {
        position: "absolute",
        top: 0,
        left: 0,
        display: "none",
        width: "100%",
        height: "100%",
    },
}

export default styles



// WEBPACK FOOTER //
// ./src/lib/components/OptimizedImage/styles.js